import React, { useState } from 'react';
import { ConfirmationDialog, BottomActionBarV2, DialogV2, AritoIcon, AritoFormV2 } from '@/components/custom/erp';
import { BoPhan, BoPhanSuDungCCDC, BoPhanSuDungCCDCInput } from '@/types/schemas';

import { FormSchema, initialFormValues, type FormValues } from '../schema';
import BasicInfoTab from './form-fields/tax-form/BasicInfoTab';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: BoPhanSuDungCCDCInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: BoPhanSuDungCCDC;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

const FormDialog: React.FC<InitialSearchDialogProps> = ({
  open,
  onClose,
  onSubmit,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  formMode,
  initialData
}) => {
  const [showErrorDialog, setShowErrorDialog] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const [boPhan, setBoPhan] = useState<BoPhan | null>(initialData?.ma_bp_phi_data || null);

  const handleSubmit = async (data: FormValues) => {
    try {
      if (!boPhan || !boPhan.uuid) {
        setErrorMessage('Mã bộ phận phí không được để trống');
        setShowErrorDialog(true);
        return;
      }

      onSubmit({
        ...data,
        ma_bp_phi: boPhan?.uuid || null
      });
      onClose();
    } catch (err: unknown) {
      const apiError = err as { response?: { data?: { detail?: unknown } } };
      if (apiError.response?.data?.detail) {
        setErrorMessage('Có lỗi xảy ra khi lưu dữ liệu');
        setShowErrorDialog(true);
      }
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={`${formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục bộ phận sử dụng công cụ'}`}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2<FormValues>
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialFormValues) as Partial<FormValues>}
          className='w-[800px]'
          headerFields={<BasicInfoTab formMode={formMode} boPhan={boPhan} setBoPhan={setBoPhan} />}
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onSubmit={() => {}}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>

      {/* Dialog thông báo lỗi */}
      <ConfirmationDialog
        open={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        onConfirm={() => setShowErrorDialog(false)}
        title='Thông báo'
        message={errorMessage}
        iconCode={260}
      />
    </>
  );
};

export default FormDialog;
